import { axiosSEC } from "../http-common";

const payment = (data: string, nit: string, idEstacionamento: string) => {
    return axiosSEC.post('Pagar/' + nit + '/' + idEstacionamento, data);
}

const PaymentServiceSiTef = {
    payment
}

export default PaymentServiceSiTef;